var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMessage)?_c('div',{staticClass:"message--wrapper",class:{ success: _vm.message.status, failure: !_vm.message.status }},[_c('span',{staticClass:"message--content"},[_c('h3',[_vm._v(_vm._s(_vm.message.text))])]),_c('span',{staticClass:"message--close",attrs:{"name":"close message"},on:{"click":_vm.close}},[_vm._v("✕")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }